const postponeNotificationMaxHour = process.env.NEXT_PUBLIC_APP_ENV === 'production' ? 24 : 3

export default postponeNotificationMaxHour
